import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";
import { img } from "@/lib/gallery";

const Tile = ({ n, title, sub, className = "" }) => (
  <div className={`group relative min-h-[260px] overflow-hidden bg-[var(--navy)] ${className}`}>
    <img src={img(n)} alt={title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#070C1A] via-[#070C1A]/20 to-transparent" />
    <div className="absolute bottom-0 left-0 p-5">
      <p className="font-display text-2xl font-bold uppercase">{title}</p>
      <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.12em] text-[var(--gold-hi)]">{sub}</p>
    </div>
  </div>
);

const Panel = ({ kicker, big, text, className = "" }) => (
  <div className={`flex min-h-[260px] flex-col justify-between border border-white/12 bg-[#0B1530] p-6 ${className}`}>
    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--gold)]">{kicker}</p>
    <div>
      <p className="font-display text-5xl font-black uppercase leading-none sm:text-6xl">{big}</p>
      <p className="mt-3 max-w-md text-sm text-[var(--steel)]">{text}</p>
    </div>
  </div>
);

export const Equipment = () => {
  const { t } = useI18n();
  const e = t.equip;
  const it = e.items;
  return (
    <section id="caracteristiques" className="bg-[var(--night)] py-24 lg:py-32" data-testid="equipment-section">
      <div className="container-x">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead index="03" eyebrow={e.eyebrow} title={e.title} />
          <Link to="/documentation/fiche-technique" data-testid="equip-specs-link" className="shrink-0 border-b border-[var(--gold)] pb-1 text-xs uppercase tracking-[0.16em] text-[var(--gold)]">{t.common.seeSpecs} →</Link>
        </div>
        <Reveal className="mt-14 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[260px_260px_260px]" data-testid="equipment-bento">
          <Tile n={9} title={it[1].t} sub={it[1].d} className="sm:col-span-2 lg:row-span-2 lg:min-h-0" />
          <Tile n={7} title={it[0].t} sub={it[0].d} className="lg:min-h-0" />
          <Tile n={8} title={it[2].t} sub={it[2].d} className="lg:min-h-0" />
          <Panel kicker={e.energyKicker} big="GAZ + 230 V" text={e.energy} className="sm:col-span-2 lg:min-h-0" />
          <Tile n={10} title={it[3].t} sub={it[3].d} className="lg:min-h-0" />
          <Tile n={11} title={it[5].t} sub={it[5].d} className="lg:min-h-0" />
          <Panel kicker={t.hero.capLabel} big={t.hero.capValue} text={t.intro.capacityNote} className="sm:col-span-2 lg:min-h-0" />
        </Reveal>
        <div className="mt-16 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3" data-testid="equipment-list">
          {it.map((x, k) => (
            <Reveal key={x.t} delay={(k % 3) * 0.05} className="flex gap-5 border-t border-white/10 py-5">
              <span className="font-mono text-xs text-[var(--gold)]">{String(k + 1).padStart(2, "0")}</span>
              <div>
                <p className="font-semibold text-white">{x.t}</p>
                <p className="mt-1 text-sm text-[var(--steel-dim)]">{x.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-xs text-[var(--steel-dim)]">{e.note}</p>
      </div>
    </section>
  );
};
